
export function sortItemsByIdList<T extends {id: string|number}>(id_list: (string|number)[], items: T[]): T[] {
  const total_items = items.length;
  return (items || []).slice().sort((a, b) => {
    const a_order = id_list.indexOf(a.id);
    const b_order = id_list.indexOf(b.id);
    return (a_order === -1 ? total_items : a_order) - (b_order === -1 ? total_items : b_order);
  })
}